import type { LegalDocument } from "@/domain/model/LegalDocuments";
import { Link } from "@mui/material";

export function LegalDocumentLink({ document }: { document: LegalDocument }) {
  return (
    <Link
      href={document.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(event) => event.stopPropagation()}
    >
      {document.title}
    </Link>
  );
}
